import * as Backbone from "backbone";
import _ from "lodash";
import {ManageView} from "module/selpan/menu/ManageView";
import {fromViewName, toViewName} from "module/selpan/menu/FieldDictSelectHelper";

export const FavFilterEntryView = Backbone.View.extend({
	className: 'FavFilterEntryView',
	events: {
		'click [data-favfilterentryview="destroyModel"]': 'destroyModel',
		'change': 'parseForm',
	},
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.selpan = options.selpan;
		this.selpan.FieldDictP.then(this.render);
	},
	destroyModel: function () {
		this.model.destroy();
	},
	parseForm: function () {
		let mergedFieldName = this.$('select').val();
		let cid = fromViewName(mergedFieldName);
		let value = this.$('input').val();
		value = value && value.trim();
		this.model.set({
			field: cid.field,
			dq2Value: cid.dq2Value,
			value: value,
		});
	},
	template: _.template('<div data-role="none" class="MenuInline" data-id="<%= m.cid %>">\n\t<div data-role="none" class="MenuRight MenuItemPassive MenuButton" data-favfilterentryview="destroyModel">\n\t\t<i class="fa fa-times"></i>\n\t</div>\n\t<select data-role="none" class="MenuSelect MenuInline">\n\t\t<option></option>\n\t\t<% _.each(dict, function(f){ %>\n\t\t<option value="<%= toViewName(f.entityField, f.dq2Value) %>"><%= f.label %></option>\n\t\t<% }); %>\n\t</select>\n\n\t<div class="MenuInline">\n\t\t<input data-role="none" class="MenuInput MenuInline" value="<%= m.get(\'value\') %>">\n\t</div>\n</div>'),
	render: function () {
		this.$el.html(this.template({
			m: this.model,
			dict: this.selpan.FieldDict.getFilterableFields(),
			toViewName: toViewName,
		}));

		// if (this.model.get('dq2label')) {
		// const cfDef = {
		// 	dqKey: 'AUFT',//this.model.get('dq2label'),
		// 	cfAttrs: [],
		// 	cfGroupId: null,
		// 	cfValiIds: [],
		// 	dqParams: [],
		// 	dstField: '',
		// 	forceDq: false,
		// 	hpos: 0,
		// 	id: NaN,
		// 	input: '1010',
		// 	insertable: false,
		// 	label: '',
		// 	length: 2000,
		// 	maxAmount: 1,
		// 	minAmount: 1,
		// 	mustMatchDq: false,
		// 	pinned: false,
		// 	primaryKey: false,
		// 	required: false,
		// 	searchable: true,
		// 	sortable: true,
		// 	startIndex: 0,
		// 	type: SisType.String,
		// 	updatable: true,
		// 	visible: true,
		// 	vpos: 0,
		// 	zpos: 0,
		// }
		// this.dqInput = new CFAjaxAutocompleteFieldView({
		// 	model: this.model,
		// 	cfDef,
		// })
		// this.$el.append(this.dqInput.el)
		// }
		this.$('select').val(toViewName(this.model.get('field'), this.model.get('dq2Value')));
	},
});

export const FavFilterManageView = ManageView.extend({
	className: 'FavFilterManageMenuView',
	ChildView: FavFilterEntryView,
});